__turbopack_context__.v({
  "loader": "equota-module-scss-module__bd4cwq__loader",
});
